import { render, staticRenderFns } from "./Step-6.vue?vue&type=template&id=b4ea59f0&"
import script from "./Step-6.vue?vue&type=script&lang=js&"
export * from "./Step-6.vue?vue&type=script&lang=js&"
import style0 from "./Step-6.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports